import { useTranslation } from 'react-i18next';

import useResendMessageLogMutation from 'components/domain/automation/messageLogs/useResendMessageLogMutation';
import useModalId from 'components/modal/useModalId';
import useAppModal from 'hooks/useAppModal';
import useNotify from 'hooks/useNotify';
import { BaseErrorResponse } from 'models/_base';
import { getErrorMessage } from 'utils/axiosExceptionUtils';
import { MessageLogViewModalFormValues } from './MessageLogViewModal.schema';

const useMessageLogViewModalFormSubmit = ({
  messageLogUid,
}: {
  messageLogUid: string;
}) => {
  const { t } = useTranslation();
  const modalId = useModalId();
  const { closeModal } = useAppModal();
  const { notifyError, notifySuccess } = useNotify();

  const onError = (error: BaseErrorResponse) => {
    notifyError(
      getErrorMessage({
        apiErrorCode: error.response?.data?.apiErrorCode,
        apiErrorMessage: error.response?.data?.apiErrorMessage ?? '',
        baseKey: 'pageAutomations.triggers.apiErrorCodes.',
        t,
      }),
    );
  };

  const onSuccess = () => {
    closeModal(modalId);
    notifySuccess(t('pageAutomations.messageLog.modal.success'));
  };

  const { mutateAsync: resendMessageLog } = useResendMessageLogMutation();

  const onSubmit = async (formValues: MessageLogViewModalFormValues) => {
    const { templateContent_htmlContent, templateSubject } = formValues;

    try {
      await resendMessageLog(
        {
          templateContent: templateContent_htmlContent,
          templateTitle: templateSubject,
          messageLogUid,
        },
        {
          onSuccess,
        },
      );
    } catch (error) {
      onError(error as BaseErrorResponse);
    }
  };

  return { onSubmit };
};

export default useMessageLogViewModalFormSubmit;
